var map = {
	"./americaGracias.tsx": "./src/ts/pages/americaGracias.tsx",
	"./camerino.tsx": "./src/ts/pages/camerino.tsx",
	"./estadio.tsx": "./src/ts/pages/estadio.tsx",
	"./gameInfo.tsx": "./src/ts/pages/gameInfo.tsx",
	"./gracias.tsx": "./src/ts/pages/gracias.tsx",
	"./guia.tsx": "./src/ts/pages/guia.tsx",
	"./habeas.tsx": "./src/ts/pages/habeas.tsx",
	"./instructions.tsx": "./src/ts/pages/instructions.tsx",
	"./internaNoticias.tsx": "./src/ts/pages/internaNoticias.tsx",
	"./limitAttempts.tsx": "./src/ts/pages/limitAttempts.tsx",
	"./loginv2.tsx": "./src/ts/pages/loginv2.tsx",
	"./lottery.tsx": "./src/ts/pages/lottery.tsx",
	"./menu.tsx": "./src/ts/pages/menu.tsx",
	"./newlogin.tsx": "./src/ts/pages/newlogin.tsx",
	"./noticias.tsx": "./src/ts/pages/noticias.tsx",
	"./noticias3D.tsx": "./src/ts/pages/noticias3D.tsx",
	"./predicciones.tsx": "./src/ts/pages/predicciones.tsx",
	"./ranking.tsx": "./src/ts/pages/ranking.tsx",
	"./ranking3D.tsx": "./src/ts/pages/ranking3D.tsx",
	"./registro.tsx": "./src/ts/pages/registro.tsx",
	"./retoSemanal.tsx": "./src/ts/pages/retoSemanal.tsx",
	"./rubigol.tsx": "./src/ts/pages/rubigol.tsx",
	"./sensei3D.tsx": "./src/ts/pages/sensei3D.tsx",
	"./tada.tsx": "./src/ts/pages/tada.tsx",
	"./tadaShop.tsx": "./src/ts/pages/tadaShop.tsx",
	"./tapa.tsx": "./src/ts/pages/tapa.tsx",
	"./trivia.tsx": "./src/ts/pages/trivia.tsx",
	"./triviaAmerica.tsx": "./src/ts/pages/triviaAmerica.tsx",
	"./triviaLottery.tsx": "./src/ts/pages/triviaLottery.tsx",
	"./tyc.tsx": "./src/ts/pages/tyc.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/ts/pages sync recursive ^\\.\\/.*\\.tsx$";